export const FACTOR_STATES = [
  { value: "requested", label: "Requested" },
  { value: "verified", label: "Verified" },
  { value: "denied_verification", label: "Unable to verify" },
];
